<template>
  <div>
    <div v-if="spinner">
      <div class="centered">
        <a-spin />
      </div>
    </div>
    <div class="p-2 border">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
          <div class="my-1">
            <b style="text-transform: capitalize;">Main order status:</b>
            <b-form-select
              class="my-2"
              v-model="mainOrderStatus"
              :options="mainOrderStatusOptions"
            ></b-form-select>
          </div>
          <div class="my-1">
            <b style="text-transform: capitalize;">Secondary status:</b>
            <b-form-select
              class="my-2"
              v-model="secondaryStatus"
              :options="secondaryStatusOptions"
            ></b-form-select>
          </div>
          <div class="my-1">
            <div class="my-1">
              <b style="text-transform: capitalize;">Days back:</b>
              <b-form-select class="my-2" v-model="daysBack">
                <option selected value="0">Select days to go back</option>
                <option v-for="(n, index) in 60" :key="index" :value="n">
                  {{ n }} days
                </option>
              </b-form-select>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
          <div class="my-1">
            <b style="text-transform: capitalize;">Batch #:</b>
            <b-form-input class="my-2" v-model="batch"></b-form-input>
          </div>
          <b style="text-transform: capitalize;">Order date range</b>

          <div class="row my-1">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <b style="text-transform: capitalize;">From:</b>
              <input
                type="date"
                :min="minOrderFrom"
                :max="maxOrderFrom"
                @change="validateDate()"
                class="form-control"
                v-model="orderDateFrom"
              />
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <b style="text-transform: capitalize;">To:</b>
              <input
                type="date"
                :min="minOrderTo"
                :max="maxOrderTo"
                @change="validateDate()"
                class="form-control"
                v-model="orderDateTo"
              />
            </div>
          </div>
          <div class="my-2">
            <b style="text-transform: capitalize;">Unhandled orders only:</b>
            <div class="form-inline my-2 mx-3">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  v-model="unhandledOrders"
                  :true-value="true"
                  :false-value="false"
                />
              </div>
              <p class="m-1" v-if="unhandledOrders">On</p>
              <p class="m-1" v-else>Off</p>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
          <div class="my-1">
            <b style="text-transform: capitalize;">Order number:</b>
            <b-form-input class="my-2" v-model="orderNumber"></b-form-input>
          </div>
          <div class="my-1">
            <b style="text-transform: capitalize;">Invoice number:</b>
            <b-form-input class="my-2" v-model="invoiceNumber"></b-form-input>
          </div>
          <div class="my-1">
            <b style="text-transform: capitalize;">Billing code:</b>
            <b-form-input class="my-2" v-model="billingCode"></b-form-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <div class="my-1">
            <b style="text-transform: capitalize;">Supplier:</b>
            <b-form-select
              class="my-2"
              v-model="suppliers"
              :options="supplierOptions"
              multiple
              :select-size="4"
            ></b-form-select>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <div class="my-1">
            <b style="text-transform: capitalize;">Company:</b>
            <b-form-select
              class="my-2"
              v-model="companies"
              :options="companyOptions"
              multiple
              :select-size="4"
            >
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
          <b-button
            @click="loadViewBatchComponent()"
            class="buttonStyle my-2"
            variant="primary"
            >View batch</b-button
          >
        </div>
        <div
          class="col-xs-12 col-sm-6 col-md-7 col-lg-7 offset-md-3 offset-lg-3"
        >
          <div class="row my-2">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <b-form-select v-model="savedSearch">
                <option
                  v-for="option in savedSearchOptions"
                  :value="option"
                  :key="option.value"
                >
                  {{ option.text }}
                </option>
              </b-form-select>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <b-button
                class="buttonStyle"
                @click="usedSavedSearch()"
                variant="primary"
                >Use saved search</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row my-3">
      <div class="col-1" v-for="day in allDays" :key="day.text">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="getRecentSavedSearch(day.values)"
          :class="{ active: getBatchProcessSavedSearchDaysBack === day.values }"
        >
          {{ day.text }}</b-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BatchProcessForm",
  data() {
    return {
      testDate: "2022-06-02",
      mainOrderStatus: "",
      mainOrderStatusOptions: [],
      secondaryStatus: "",
      secondaryStatusOptions: [],
      daysBack: 0,
      batch: "",
      orderDateFrom: "",
      orderDateTo: "",
      unhandledOrders: true,
      orderNumber: "",
      invoiceNumber: "",
      billingCode: "",
      suppliers: [],
      supplierOptions: [],
      companies: [],
      companyOptions: [],
      savedSearch: null,
      savedSearchOptions: [],
      fields: [
        "batch_number",
        "batch_type",
        "created",
        "handled",
        "fax",
        "email",
        "DB",
        "Q.DB",
        "delete",
      ],
      items: [],
      daysBackButton: 2,
      spinner: false,
      minOrderFrom: "",
      maxOrderFrom: "",
      minOrderTo: "",
      maxOrderTo: "",
    };
  },
  methods: {
    loadViewBatchComponent() {
      this.spinner = true;

      this.$store.commit(
        "batchProcess/SET_BATCH_PROCESS_IS_SAVE_SEARCH_REDIRECT",
        {
          redirect: false,
          showOrderDetails: {
            batchNumber: "",
            createdDate: "",
            batchName: "",
          },
        }
      );

      this.$store.commit("batchProcess/SET_VIEW_BATCH_UPDATE_MESSAGE", {
        message: "",
        color: "",
      });

      this.$store.commit("batchProcess/SET_BATCH_MESSAGE", {
        message: "",
        color: "",
      });

      if (
        (this.orderDateFrom && this.orderDateTo) ||
        (!this.orderDateFrom && !this.orderDateTo)
      ) {
        var params = {
          order_status_code: this.mainOrderStatus,
          batch_number: this.batch,
          order_number: this.orderNumber,
          secondary_status_code: this.secondaryStatus,
          start_date: this.orderDateFrom,
          end_date: this.orderDateTo,
          invoice_number: this.invoiceNumber,
          days_back: +this.daysBack,
          unhandled_orders_only: this.unhandledOrders,
          billing_code: this.billingCode,
          supplier_ids: this.suppliers.filter((id) => {
            return id != "";
          }),
          company_ids: this.companies.filter((id) => {
            return id != "";
          }),
        };

        this.scrollToTop();

        if (this.$route.name != "BatchProcessViewBatch") {
          this.$router.push({ name: "BatchProcessViewBatch" });
        }

        this.$store.commit("batchProcess/SET_VIEW_BATCH_STORE_PARAMS", params);

        this.$store.commit("batchProcess/SET_TABLE_STATUS", "Processing");

        var new_params = {
          bodyParams: params,
          params: {
            pg_num: this.viewBatchPagination.pageNo,
            pg_size: this.viewBatchPagination.pageSize,
          },
        };

        this.getViewBatchAllList(new_params);
        this.unhandledOrders = true;
      } else if (
        (this.orderDateFrom && !this.orderDateTo) ||
        (!this.orderDateFrom && this.orderDateTo)
      ) {
        this.spinner = false;

        this.scrollToTop();

        this.$store.commit("batchProcess/SET_BATCH_MESSAGE", {
          message: "Select From as well as To date",
          color: "red",
        });
      }
    },
    getViewBatchAllList(params) {
      this.$store
        .dispatch("batchProcess/fetchAllViewBatchList", params)
        .then(() => {
          this.spinner = false;
          this.$store.commit(
            "batchProcess/SET_TABLE_STATUS",
            "No records found"
          );
        })
        .catch(() => {
          console.log("error occured from batch process form view batch");
        });
    },
    usedSavedSearch() {
      this.$store.commit("batchProcess/SET_VIEW_BATCH_UPDATE_MESSAGE", {
        message: "",
        color: "",
      });

      if (this.savedSearch.value) {
        this.spinner = true;
        this.$store
          .dispatch("batchProcess/fetchSavedSearchById", {
            id: this.savedSearch.value,
          })
          .then(() => {
            this.spinner = false;
            this.scrollToTop();
          })
          .catch(() => {
            console.log("error occured from batch process form view batch");
          });
      }
    },
    getRecentSavedSearch(day) {
      this.$store.commit(
        "batchProcess/SET_BATCH_PROCESS_SAVED_SEARCH_DAYS_BACK",
        day
      );

      this.$store.commit("batchProcess/SET_VIEW_BATCH_UPDATE_MESSAGE", {
        message: "",
        color: "",
      });

      this.$store.commit("batchProcess/SET_BATCH_MESSAGE", {
        message: "",
        color: "",
      });

      this.$store.commit(
        "batchProcess/SET_BATCH_PROCESS_SAVED_SEARCH_LIST",
        []
      );

      this.$router.push({ name: "BatchProcessSavedSearch" });

      var params = {
        daysback: this.getBatchProcessSavedSearchDaysBack,
        pg_num: this.getBatchProcessSavedSearchPagination.pageNo,
        pg_size: this.getBatchProcessSavedSearchPagination.pageSize,
      };

      this.$store
        .dispatch("batchProcess/fetchBatchProcessSavedSearch", params)
        .then(() => {
          this.scrollToTop();
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    validateDate() {
      if (this.orderDateFrom && !this.orderDateTo) {
        this.minOrderTo = this.orderDateFrom;
        this.maxOrderFrom = "";
      } else if (!this.orderDateFrom && this.orderDateTo) {
        this.maxOrderFrom = this.orderDateTo;
        this.minOrderTo = "";
      } else if (!this.orderDateFrom && !this.orderDateTo) {
        this.minOrderFrom = "";
        this.maxOrderFrom = "";
        this.minOrderTo = "";
        this.maxOrderTo = "";
      } else {
        this.minOrderTo = this.orderDateFrom;
        this.maxOrderFrom = this.orderDateTo;
      }
    },
  },

  computed: {
    allDays() {
      return this.$store.getters["batchProcess/getAllDays"];
    },
    searchAndBatchFlag() {
      return this.$store.getters["batchProcess/getSavedSearchAndViewBatchFlag"];
    },
    mainOrderStatusArr() {
      return this.$store.getters["batchProcess/getMainOrderStatusArr"];
    },
    secondaryStatusArr() {
      return this.$store.getters["batchProcess/getSecondaryStatusArr"];
    },
    allSuppliersArr() {
      return this.$store.getters["batchProcess/getAllSuppliersArr"];
    },
    allCompaniesArr() {
      return this.$store.getters["batchProcess/getAllCompaniesArr"];
    },
    savedSerches() {
      return this.$store.getters["batchProcess/getSavedSerches"];
    },
    viewBatchPagination() {
      return this.$store.getters["batchProcess/getViewBatchPagination"];
    },
    getViewBatchStoreParams() {
      return this.$store.getters["batchProcess/getViewBatchStoreParams"];
    },
    getBatchProcessSavedSearchPagination() {
      return this.$store.getters[
        "batchProcess/getBatchProcessSavedSearchPagination"
      ];
    },
    getBatchProcessSavedSearchDaysBack() {
      return this.$store.getters[
        "batchProcess/getBatchProcessSavedSearchDaysBack"
      ];
    },
    getViewBatchStoreParamsAll() {
      return this.$store.getters["batchProcess/getViewBatchStoreParamsAll"];
    },
    getIsBatchProcessSaveSearchRedirection() {
      return this.$store.getters[
        "batchProcess/getIsBatchProcessSaveSearchRedirection"
      ];
    },
  },
  watch: {
    mainOrderStatusArr(mainOrderStatusArr) {
      var datas = [{ value: "", text: "Any" }];
      mainOrderStatusArr.map(function(data) {
        datas.push({
          value: data.code,
          text: `${data.name} [ ${data.total} records ]`,
        });
      });

      this.mainOrderStatusOptions = datas;
    },
    secondaryStatusArr(secondaryStatusArr) {
      var datas = [{ value: "", text: "All status codes" }];
      secondaryStatusArr.map(function(data) {
        datas.push({
          value: data.code,
          text: `( ${data.code} ) ${data.name}`,
        });
      });
      this.secondaryStatusOptions = datas;
    },
    allSuppliersArr(allSuppliersArr) {
      var datas = [{ value: "", text: "All suppliers" }];
      allSuppliersArr.map(function(data) {
        datas.push({
          value: data.id,
          text: data.name,
        });
      });
      this.supplierOptions = datas;
    },
    allCompaniesArr(allCompaniesArr) {
      var datas = [{ value: "", text: "All companies" }];
      allCompaniesArr.map(function(data) {
        datas.push({
          value: data.id,
          html: data.name,
        });
      });
      this.companyOptions = datas;
    },
    savedSerches(savedSerches) {
      var datas = [{ value: 0, text: "Select any saved search" }];
      savedSerches.map(function(data) {
        datas.push({
          value: data.search_id,
          text: data.title,
        });
      });
      this.savedSearch = savedSerches.length > 0 ? datas[0] : null;
      this.savedSearchOptions = datas;
    },
    getViewBatchStoreParamsAll(getViewBatchStoreParamsAll) {
      if (Object.keys(getViewBatchStoreParamsAll).length > 0) {
        var datasForFields =
          getViewBatchStoreParamsAll.form_packet.data.struct.var;
        datasForFields.forEach((field) => {
          if (field.key === "SMASTERSTATUS") {
            this.mainOrderStatus = field.value;
          }
          if (field.key === "batchlabel") {
            this.batch = field.value;
          }
          if (field.key === "SORDERNUM") {
            this.orderNumber = field.value;
          }
          if (field.key === "SSTATUSCODE") {
            this.secondaryStatus = field.value;
          }
          if (field.key === "SBEGINDATE") {
            this.orderDateFrom = field.value;
            this.validateDate();
          }
          if (field.key === "SENDDATE") {
            this.orderDateTo = field.value;
            this.validateDate();
          }
          if (field.key === "SINVOICENUM") {
            this.invoiceNumber = field.value;
          }
          if (field.key === "SDAYSBACK") {
            this.daysBack = field.value;
          }
          if (field.key === "SDATETYPE") {
            this.unhandledOrders = field.value === "0" ? false : true;
          }
          if (field.key === "SBILLINGCODE") {
            this.billingCode = field.value;
          }
          if (field.key === "SSUPPLIER") {
            this.suppliers = field.value.split(",").map(Number);
          }
          if (field.key === "SCOMPANY") {
            this.companies =
              field.value.length == 1 && field.value[0] == 0
                ? []
                : field.value.split(",").map(Number);
          }
        });
      }
    },
  },
  created() {
    this.scrollToTop();
    this.$store.dispatch("batchProcess/fetchMainOrderStatus");
    this.$store.dispatch("batchProcess/fetchSecondaryStatus");
    this.$store.dispatch("batchProcess/fetchAllSuppliers");
    this.$store.dispatch("batchProcess/fetchAllCompanies");
    this.$store.dispatch("batchProcess/fetchAllSavedSearch");
    this.$store.commit("batchProcess/SET_VIEW_BATCH_STORE_PARAMS", {
      order_status_code: this.mainOrderStatus,
      batch_number: this.batch,
      order_number: this.orderNumber,
      secondary_status_code: this.secondaryStatus,
      start_date: this.orderDateFrom,
      end_date: this.orderDateTo,
      invoice_number: this.invoiceNumber,
      days_back: +this.daysBack,
      unhandled_orders_only: this.unhandledOrders,
      billing_code: this.billingCode,
      supplier_ids: this.suppliers,
      company_ids: this.companies,
    });
    this.$store.commit("batchProcess/SET_VIEW_BATCH_UPDATE_MESSAGE", {
      message: "",
      color: "",
    });
    this.$store.commit("batchProcess/SET_BATCH_MESSAGE", {
      message: "",
      color: "",
    });
  },
};
</script>
<style lang="scss" scoped>
form {
  border: 1px solid #ccc;
  padding: 25px;
  border-radius: 5px;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
  margin-left: -1.5em !important;
}

.centered {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 9999;
}

.table-active {
  opacity: 0.5;
}

.buttonStyle {
  border-radius: 1.5rem;
  // padding: 10px 20px;
}

.buttonColor {
  background-color: #3782f3;
  color: white;
}
</style>
